import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.343 17.657a8 8 0 1 0 0 -11.314","key":"svg-0"}],["path",{"d":"M13.828 9.172a4 4 0 1 0 0 5.656","key":"svg-1"}]]

const IconBrandComedyCentral = createReactComponent('outline', 'brand-comedy-central', 'BrandComedyCentral', __iconNode);

export default IconBrandComedyCentral;